import { ArrowLeftRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { QuoteComparison } from "@/components/admin/QuoteComparison";

/* ------------------------------------------------------------------ */
/* side-by-side fee comparison for a repeat customer                   */
/* ------------------------------------------------------------------ */

/**
 * Opened from a lead, so the quote you were looking at is highlighted among
 * the rest. The lead panel steps aside while this is open - the comparison
 * needs the width - and is put back the moment the comparison is closed, so
 * the team never loses its place.
 */
export const CompareDialog = ({ lead, onClose }) => {
  if (!lead) return null;

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        data-testid="quote-comparison-dialog"
        className="max-h-[90vh] overflow-y-auto bg-white sm:max-w-3xl lg:max-w-5xl"
      >
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 pr-8 text-lg">
            <ArrowLeftRight className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
            {lead.full_name}&apos;s quotes, side by side
          </DialogTitle>
          <DialogDescription>
            Oldest first, with what each fee did since their previous quote for the same
            service.
          </DialogDescription>
        </DialogHeader>
        <QuoteComparison quoteRef={lead.quote_ref} />
      </DialogContent>
    </Dialog>
  );
};
